import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql, navigate, withPrefix } from 'gatsby';
import { getUserLangKey } from 'ptz-i18n';

import SEO from '../SEO';

// * GetLangPreference is true when a user hits a route like /parents
// * GetLangPreference is false when a user hits a route like /in-en/parents

const Redirect = ({ data, location, getLangPreference, origin }) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // * Our Default Lang for the site
      const defaultLangKey = 'en-ca';
      // * Array of all langs for the website
      const langs = data.prodigy.localeMappings.map(
        langData => langData.locale
      );
      // * Check if it should redirect to defaultlang, or get a user's pref lang
      const langKey = getLangPreference
        ? getUserLangKey(langs, defaultLangKey)
        : defaultLangKey;
      // * Need to match returned lang with correct path
      const prefix = data.prodigy.localeMappings.find(
        localeData => localeData.locale === langKey
      );
      // * The Url to be navigated to
      const url = getLangPreference
        ? withPrefix(`/${prefix.path}/${location}`)
        : withPrefix(`/${prefix.path}/`);

      navigate(url);
    }
  }, []);

  return <SEO location={origin} />;
};

Redirect.propTypes = {
  data: PropTypes.shape().isRequired,
  location: PropTypes.string.isRequired,
  origin: PropTypes.string.isRequired,
  getLangPreference: PropTypes.bool.isRequired,
};

// * StaticQuery Component that retrieves and passes in all the articles
const withStaticQueryRedirect = ({ location, getLangPreference, origin }) => {
  return (
    <StaticQuery
      query={graphql`
        query LocaleMappingQuery {
          prodigy {
            localeMappings {
              path
              locale
            }
          }
        }
      `}
      render={data => (
        <Redirect
          data={data}
          origin={origin}
          location={location}
          getLangPreference={getLangPreference}
        />
      )}
    />
  );
};

withStaticQueryRedirect.propTypes = {
  location: PropTypes.string.isRequired,
  getLangPreference: PropTypes.bool,
  origin: PropTypes.string.isRequired,
};

withStaticQueryRedirect.defaultProps = {
  getLangPreference: true,
};

export default withStaticQueryRedirect;
